<template>
  <div class="loading" v-bind:class='{openSite:closeOverdsp}' v-show="showLoading">
    <div class="spinner">
      <div class="dot1"></div>
      <div class="dot2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name:'loadingAnimation',
  data() { return{closeOverdsp:false, showLoading:true} },
  methods: {
    appear() {
      this.closeOverdsp = false
      this.showLoading = true
    },
    ending() {
      this.closeOverdsp = true
      document.addEventListener('animationend', ()=> {this.showLoading = false})
      document.addEventListener('webkitAnimationEnd', ()=> {this.showLoading = false})
    },
  }
}
</script>

<style>
</style>
